import React, { useReducer } from "react";
import axios from "axios";
import TouchesContext from "./touchesContext";
import touchesReducer from "./touchesReducer";

import {
  GET_TOUCHES,
  TOUCHES_ERROR,
  DELETE_TOUCH,
  SET_CURRENT,
  CLEAR_CURRENT,
  FILTER_TOUCHES,
  CLEAR_FILTER,
  GET_DROPDOWNS,
  SET_SUBSCRIPTION,
  SET_CLIENT
} from "../types";

const TouchesState = props => {
  const initialState = {
    touches: null,
    client: null,
    subscription: null,
    dropdowns: null,
    current: null,
    filtered: null,
    error: null
  };

  const [state, dispatch] = useReducer(touchesReducer, initialState);

  // Get Touches
  const getTouches = async () => {
    try {
      const res = await axios.get(`/api/v1/touches`);
      dispatch({
        type: GET_TOUCHES,
        payload: res.data
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: TOUCHES_ERROR,
        payload: err.message
      });
    }
  };

  //Delete Touch
  const deleteTouch = async id => {
    try {
      await axios.delete(`/api/v1/touches/${id}`);
      dispatch({
        type: DELETE_TOUCH,
        payload: id
      });
    } catch (err) {
      dispatch({
        type: TOUCHES_ERROR,
        payload: err.message
      });
    }
  };

  //Set Current Touch
  const setCurrent = touch => {
    dispatch({ type: SET_CURRENT, payload: touch });
  };

  //Clear Current Touch

  const clearCurrent = () => {
    dispatch({ type: CLEAR_CURRENT });
  };

  //Filter Touches
  const filterTouches = text => {
    dispatch({ type: FILTER_TOUCHES, payload: text });
  };

  //Clear Filter
  const clearFilter = () => {
    dispatch({ type: CLEAR_FILTER });
  };

  //Get Dropdowns Values for Touch Componet
  const getDropdowns = async () => {
    try {
      const res = await axios.get(
        "/api/v1/dropdowns/dropdown?component=subscriptions"
      );
      dispatch({
        type: GET_DROPDOWNS,
        payload: res.data.data
      });
    } catch (err) {
      dispatch({
        type: TOUCHES_ERROR,
        payload: err.message
      });
    }
  };

  //Set Subscription
  const setSubscription = subscription => {
    dispatch({ type: SET_SUBSCRIPTION, payload: subscription });
  };

  //Set Client
  const setClient = client => {
    dispatch({ type: SET_CLIENT, payload: client });
  };

  //Add Client and Subscription
  const addClientAndSubscription = async (
    client,
    touch,
    subscription,
    currentUser
  ) => {
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };
    try {
      const res = await axios.put(
        "api/v1/touches/clientAppSub",
        {
          clientName: client.name,
          contactName: client.contactName,
          contactEmail: client.contactEmail,
          contactPhone: client.contactPhone,
          appName: touch.appName,
          cutOffDate: subscription.cutOffDate,
          licensed: subscription.licensed,
          paidCurrent: subscription.paidCurrent,
          terms: subscription.terms,
          gracePeriodDays: subscription.gracePeriodDays,
          lastUpdatedBy: currentUser,
          message: subscription.message
        },
        config
      );
      dispatch({
        type: GET_TOUCHES,
        payload: res.data
      });
    } catch (err) {
      dispatch({
        type: TOUCHES_ERROR,
        payload: err.message
      });
    }
  };

  return (
    <TouchesContext.Provider
      value={{
        touches: state.touches,
        client: state.client,
        subscription: state.subscription,
        current: state.current,
        filtered: state.filtered,
        dropdowns: state.dropdowns,
        error: state.error,
        getTouches,
        deleteTouch,
        setCurrent,
        clearCurrent,
        filterTouches,
        clearFilter,
        //clearTouches,
        getDropdowns,
        addClientAndSubscription,
        setSubscription,
        setClient
      }}
    >
      {props.children}
    </TouchesContext.Provider>
  );
};

export default TouchesState;
